import React from 'react';
import PropTypes from 'prop-types';
import moment from '@narvar/moment-shim';
import { NUMBER_OF_PICKUP_DAYS } from '../../constants/pickups';
import { PickupCalendarContainer } from '../PickupsPage/PickupStyles';
import PickupCarousel from '../PickupsPage/PickupCarousel';
import { store } from '../../store';
import { localeDateTime } from '../../lib/dates';

const CalendarDateItem = ({ date, disabled, selected, ctaColor, onClick }) => {
  const { page: { countryCode } } = store.getState();
  const momentDate = moment(date);
  const dayOfWeek = momentDate.format('ddd');
  const monthAndDay = localeDateTime({ date, countryCode, formatType: 'shortDate' });

  return (
    <PickupCalendarContainer
      disabled={disabled}
      selected={selected}
      ctaColor={ctaColor}
      onClick={onClick}
    >
      <strong>{dayOfWeek}</strong>
      <div style={{ fontSize: '0.75rem' }}>{monthAndDay}</div>
    </PickupCalendarContainer>
  );
};

CalendarDateItem.defaultProps = {
  disabled: false,
  selected: false,
  ctaColor: '#000000',
  onClick: () => {},
};

CalendarDateItem.propTypes = {
  date: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  selected: PropTypes.bool,
  ctaColor: PropTypes.string,
  onClick: PropTypes.func,
};

const CalendarDate = ({ selectedDate, dates, ctaColor, onDateChange }) => (
  <PickupCarousel
    items={dates}
    render={({ date, eligible, timeZone }) => (
      <CalendarDateItem
        key={date}
        disabled={!eligible}
        date={date}
        ctaColor={ctaColor}
        selected={selectedDate === date}
        onClick={() => {
          if (!eligible) return;
          onDateChange(date, timeZone);
        }}
      />
    )}
    slidesToShow={NUMBER_OF_PICKUP_DAYS}
  />
);

CalendarDate.defaultProps = {
  ctaColor: '#000000',
  selectedDate: undefined,
  dates: [],
  onDateChange: () => {},
};

CalendarDate.propTypes = {
  onDateChange: PropTypes.func,
  selectedDate: PropTypes.string,
  dates: PropTypes.arrayOf(
    PropTypes.shape({ date: PropTypes.string.isRequired, eligible: PropTypes.bool.isRequired }),
  ),
  ctaColor: PropTypes.string,
};

export default CalendarDate;
